import * as React from "react";
import { onlyUnique } from 'src/Library/Helper';

const useTabs = (length: number) => {
  const [visiblePanes, setVisiblePanes] = React.useState(Array.from({length}, (_, i) => (i + 1).toString()));
  const [activeKey, setActiveKey] = React.useState('1');

  React.useEffect(() => {
    setActiveKey(visiblePanes[0]);
  }, [visiblePanes]);

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const hide = (keys: string[]) => {
    if (visiblePanes.some(key => keys.includes(key))) {
      setVisiblePanes(visiblePanes.filter(pane => !keys.includes(pane)).sort());
    }
  };

  const show = (keys: string[]) => {
    if (keys.some(key => !visiblePanes.includes(key))) {
      setVisiblePanes([...visiblePanes, ...keys].filter(onlyUnique).sort());
    }
  };

  const hideAll = () => {
    setVisiblePanes([]);
  };

  const showAll = () => {
    setVisiblePanes(Array.from({length}, (_, i) => (i + 1).toString()));
  };

  return {
    onChange,
    activeKey,
    hide,
    show,
    hideAll,
    showAll,
    visiblePanes,
  };
};

export default useTabs;
